import { usePremiumIntent, useStandardIntent } from '@/components/user-context/helpers/cohorts';

import { LoggedInJiraFree } from './free/logged-in-jira-free';
import { LoggedInJiraPremium } from './premium/logged-in-jira-premium';
import { LoggedInJiraStandard } from './standard/logged-in-jira-standard';

export const LoggedInJira = () => {
	const isStandard = useStandardIntent();
	const isPremium = usePremiumIntent();

	if (isStandard) {
		return <LoggedInJiraStandard />;
	}

	if (isPremium) {
		return <LoggedInJiraPremium />;
	}

	return <LoggedInJiraFree />;
};
